export const MODELS_HISTORY_TAB_ITEMS = [
  { value: "all", label: "All" },
  { value: "approvals", label: "Approvals" },
  { value: "versions", label: "Versions" },
] as const;

export const MODELS_HISTORY_PERIOD_OPTIONS = [
  { value: "all", label: "All time" },
  { value: "last-24-hours", label: "Last 24 hours" },
  { value: "last-7-days", label: "Last 7 days" },
  { value: "last-28-days", label: "Last 28 days" },
] as const;

export const MODELS_HISTORY_SCOPE_OPTIONS = [
  { value: "all", label: "All models" },
  { value: "published", label: "Published" },
  { value: "draft", label: "Draft" },
] as const;

export type ModelsHistoryToolbarTab = (typeof MODELS_HISTORY_TAB_ITEMS)[number]["value"];
export type ModelsHistoryPeriodFilter = (typeof MODELS_HISTORY_PERIOD_OPTIONS)[number]["value"];
export type ModelsHistoryScopeFilter = (typeof MODELS_HISTORY_SCOPE_OPTIONS)[number]["value"];
